import {
    Box,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import CallIcon from "@material-ui/icons/Call";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ContactSupport from "@material-ui/icons/ContactSupport";
import Description from "@material-ui/icons/Description";
import ExitToApp from "@material-ui/icons/ExitToApp";
import HomeWork from "@material-ui/icons/HomeWork";
import ListAlt from "@material-ui/icons/ListAlt";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import People from "@material-ui/icons/People";
import RestorePage from "@material-ui/icons/RestorePage";
import GroupIcon from "@mui/icons-material/Group";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SummarizeIcon from "@mui/icons-material/Summarize";
import Config from "Config";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Constant } from "../../Constant";
import { getIsHideSearchPageRoles } from "../../Utils";
import CustomHotlineDialog from "../../component/CustomHotlineDialog/CustomHotlineDialog";
import { updateMobileNavStatus } from "../../redux/action";
import {
    getAllCollBoxGroupAuth,
    getMobileNavStatus,
    getToken,
    getUserRole,
} from "../../redux/selector";
import "./PortalNavbar.scss";

export default function PortalNavbar() {
    const { t, i18n } = useTranslation();
    const token = useSelector(getToken());
    const role = useSelector(getUserRole());
    const navigate = useNavigate();
    const allCollBoxGroupAuth = useSelector(getAllCollBoxGroupAuth());
    const [sideNavList, setSideNavList] = useState([]);
    const [popupFormId, setPopupFormId] = useState(0);
    //console.log("profile interfaceUserName is: "+profile.interfaceUsername);

    const popDialog = () => {
        setPopupFormId(99999); //default no form
    };

    function filterByRole(item) {
        /**
         *      0 - login
         *      1 - profile
         *      7 - parameterPage
         *      8 - delegationPage
         *      9 - staff
         *      10 - org
         *      11 - editReviewerEdb
         *      12 - editFormOwner
         *      13 - Form Selection
         *      14 - Form Enquiry
         *      15 - History Enquiry
         *      17 - HealthCheck
         *      18 - MonthlySubmissionReport
         *      19 - SystemMessage
         *      20 - editPostSecondary
         *      105 - EditResponsibleGroup
         *      999 - hotline
         */
        let hidePageArr = [];
        if (getIsHideSearchPageRoles(role)) {
            hidePageArr = [14, 15];
        }
        switch (role) {
            case "SA":
                return ![9, 11, 7, 8, 0, 13]
                    .concat(hidePageArr)
                    .includes(item.id);
            case "CH":
            case "SH":
                return ![0, 7, 10, 11, 12, 9, 15, 16, 17, 18, 105, 19, 20]
                    .concat(hidePageArr)
                    .includes(item.id);
            case "SLA":
            case "CLA":
                return ![0, 7, 10, 11, 12, 15, 16, 17, 18, 105, 19, 20]
                    .concat(hidePageArr)
                    .includes(item.id);
            case "FO":
                return ![0, 8, 10, 12, 9, 13, 15, 16, 17, 18, 19, 20]
                    .concat(hidePageArr)
                    .includes(item.id);
            case "Public":
            case "C":
            case "S":
                return ![0, 11, 10, 12, 7, 8, 9, 15, 16, 17, 18, 105, 19, 20]
                    .concat(hidePageArr)
                    .includes(item.id);
            case "FR":
            case "E":
                return ![0, 11, 10, 12, 7, 8, 9, 13, 15, 16, 17, 18, 19, 20]
                    .concat(hidePageArr)
                    .includes(item.id);
            default:
                return ![
                    11, 10, 12, 7, 8, 9, 1, 13, 14, 15, 16, 17, 18, 105, 19, 20,
                ]
                    .concat(hidePageArr)
                    .includes(item.id);
        }
    }

    // let arrByID = arr.filter(filterByID);
    const isMobileNavOpen = useSelector(getMobileNavStatus());
    const dispatch = useDispatch();

    function updateIsMobileNavOpen() {
        dispatch(updateMobileNavStatus(isMobileNavOpen));
    }

    const handleClose = () => {
        setPopupFormId(0);
    };

    const redirect = (url) => {
        navigate(url);
    };

    useEffect(() => {
        let initSideNavList = [
            {
                id: 0,
                name: "login",
                component: <ExitToApp />,
                url: "/Login",
            },
            {
                id: 1,
                name: "profilePage",
                component: <AccountCircle />,
                url: "/ProfilePage",
            },
            {
                id: 7,
                name: "parameterPage",
                component: <Description />,
                url: "/ParameterPage",
            },
            {
                id: 8,
                name: "delegationPage",
                component: <People />,
                url: "/DelegationPage",
            },
            {
                id: 9,
                name: "editStaff",
                component: <AssignmentInd />,
                url: "/EditStaff",
            },
            {
                id: 10,
                name: "editOrgEdb",
                component: <HomeWork />,
                url: "/EditOrgEdb",
            },
            {
                id: 20,
                name: "editPostSecondary",
                component: <HomeWork />,
                url: "/EditPostSecondary",
            },
            {
                id: 11,
                name: "editReviewerEdb",
                component: <AssignmentInd />,
                url: "/EditReviewerEdb",
            },
            {
                id: 12,
                name: "editFormOwner",
                component: <AssignmentInd />,
                url: "/EditFormOwner",
            },

            {
                id: 105,
                name: "editPurpose",
                component: <GroupIcon />,
                url: "/EditPurpose",
            },
            {
                id: 13,
                name: "formSelect",
                component: <ListAlt />,
                url: "/select",
            },
            {
                id: 14,
                name: "formEnquiry",
                component: <SearchRoundedIcon />,
                url: "/FormEnquiry",
            },
            {
                id: 15,
                name: "historyEnquiry",
                component: <RestorePage />,
                url: "/HistoryEnquiry",
            },
            {
                id: 19,
                name: "systemMessage",
                component: <GroupIcon />,
                url: "/SystemMessage",
            },
            {
                id: 17,
                name: "healthcheck",
                component: <LocalHospitalIcon />,
                url: "/HealthCheck",
            },
            {
                id: 18,
                name: "MonthlySubmissionReport",
                component: <SummarizeIcon />,
                url: "/MonthlySubmissionReport",
            },
            {
                id: 998,
                name: "faq",
                component: <ContactSupport />,
                url: "/Faq",
            },
            {
                id: 999,
                name: "hotline",
                component: <CallIcon />,
                url: "",
                click: popDialog,
            },
        ].filter(filterByRole);
        let sideNavList = [];
        if (allCollBoxGroupAuth) {
            sideNavList = initSideNavList;
        } else {
            sideNavList = initSideNavList.filter((item) => item.id !== 105);
        }
        setSideNavList(sideNavList);
    }, [allCollBoxGroupAuth, role]);

    return (
        <Box style={{ position: "relative" }}>
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <Box
                    component="nav"
                    style={{
                        width: i18n.language === "en" ? "225px" : "max-content",
                    }}
                >
                    {/* <NavLink to={navItem.url} className="navItem"> */}
                    <List style={{ padding: 0 }}>
                        {sideNavList.map((navItem) => (
                            <Fragment key={navItem.id}>
                                <ListItem
                                    tabIndex="0"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "50px",
                                        cursor: "pointer",
                                    }}
                                    onClick={
                                        navItem.click
                                            ? navItem.click
                                            : () => {
                                                  redirect(`/${navItem.url}`);
                                              }
                                    }
                                >
                                    <ListItemIcon>
                                        {navItem.component}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={t(
                                            `common.sideNavList.${navItem.name}`
                                        )}
                                    ></ListItemText>
                                </ListItem>
                                <Divider />
                            </Fragment>
                        ))}
                    </List>
                    {/* </NavLink> */}
                    <Box
                        style={{
                            paddingTop: "20px",
                            textAlign: "center",
                            color: "#666",
                        }}
                    >
                        {Config.VERSION ? Config.VERSION : ""}
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: { xs: "block", sm: "none" } }}>
                <Drawer
                    anchor="right"
                    open={isMobileNavOpen}
                    onClose={updateIsMobileNavOpen}
                >
                    <List>
                        <ListItem>
                            <IconButton onClick={updateIsMobileNavOpen}>
                                <ChevronRight />
                                <p className="hidden">&#62;</p>
                            </IconButton>
                        </ListItem>
                        {sideNavList.map((navItem) => (
                            <Box
                                style={{ cursor: "pointer" }}
                                key={navItem.id}
                                onClick={
                                    navItem.click
                                        ? navItem.click
                                        : () => {
                                              redirect(`/${navItem.url}`);
                                          }
                                }
                            >
                                {/* <NavLink to={navItem.url} className="navItem"> */}
                                <ListItem
                                    button
                                    key={navItem.id}
                                    onClick={updateIsMobileNavOpen}
                                >
                                    <ListItemIcon>
                                        {navItem.component}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={t(
                                            `common.sideNavList.${navItem.name}`
                                        )}
                                    ></ListItemText>
                                </ListItem>
                                {/* </NavLink> */}
                                <Divider />
                            </Box>
                        ))}
                        <Box
                            style={{
                                paddingTop: "20px",
                                textAlign: "center",
                                color: "#666",
                            }}
                        >
                            {Config.VERSION ? Config.VERSION : ""}
                        </Box>
                    </List>
                </Drawer>
            </Box>
            <CustomHotlineDialog
                onClose={handleClose}
                formId={popupFormId}
                popupHotLineTitle={t(`common.sideNavList.hotline`)}
            />

            <Box
                style={{
                    position: "relative",
                    left: 0,
                    bottom: "-50px",
                    width: "100%",
                    textAlign: "center",
                    color: "#ccc",
                }}
            >
                {Constant.version ? Constant.version : ""}
            </Box>
        </Box>
    );
}
